/**
 * Einkaufswelt: Block + Element "Riccardo Deals"
 */
const { Component, Mixin } = Shopware;

Component.register('sw-cms-el-riccardo-deals', {
    template: `
        <div class="sw-cms-el-riccardo-deals" style="padding: 24px; border: 2px dashed #E30613; border-radius: 12px; text-align: center;">
            <strong style="font-size: 18px;">{{ element.config.title.value || 'Deals' }}</strong>
            <p style="margin: 8px 0 0; color: #52667a;">Zeigt bis zu {{ element.config.limit.value }} aktive Deals aus „Marketing → Riccardo Deals“.</p>
        </div>
    `,
    mixins: [Mixin.getByName('cms-element')],
    created() {
        this.initElementConfig('riccardo-deals');
    },
});

Component.register('sw-cms-el-config-riccardo-deals', {
    template: `
        <div class="sw-cms-el-config-riccardo-deals">
            <sw-text-field v-model:value="element.config.title.value" label="Überschrift" />
            <sw-number-field v-model:value="element.config.limit.value" number-type="int" :min="0" label="Maximale Anzahl (0 = alle)" />
        </div>
    `,
    mixins: [Mixin.getByName('cms-element')],
    created() {
        this.initElementConfig('riccardo-deals');
    },
});

Component.register('sw-cms-el-preview-riccardo-deals', {
    template: `<div style="padding: 12px; font-weight: 700; color: #E30613; text-align: center;">Riccardo Deals</div>`,
});

Component.register('sw-cms-block-riccardo-deals', {
    template: `<div class="sw-cms-block-riccardo-deals"><slot name="content"></slot></div>`,
});

Component.register('sw-cms-preview-riccardo-deals', {
    template: `
        <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 6px; padding: 10px;">
            <div style="height: 48px; border-radius: 6px; background: #FF7A6B;"></div>
            <div style="height: 48px; border-radius: 6px; background: #E30613;"></div>
            <div style="height: 48px; border-radius: 6px; background: #FFD66B;"></div>
        </div>
    `,
});

Shopware.Service('cmsService').registerCmsElement({
    name: 'riccardo-deals',
    label: 'Riccardo Deals',
    component: 'sw-cms-el-riccardo-deals',
    configComponent: 'sw-cms-el-config-riccardo-deals',
    previewComponent: 'sw-cms-el-preview-riccardo-deals',
    defaultConfig: {
        title: { source: 'static', value: 'Deals der Woche' },
        limit: { source: 'static', value: 4 },
    },
});

Shopware.Service('cmsService').registerCmsBlock({
    name: 'riccardo-deals',
    label: 'Riccardo Deals',
    category: 'commerce',
    component: 'sw-cms-block-riccardo-deals',
    previewComponent: 'sw-cms-preview-riccardo-deals',
    defaultConfig: { marginBottom: '20px', marginTop: '20px', marginLeft: '0', marginRight: '0', sizingMode: 'boxed' },
    slots: { content: 'riccardo-deals' },
});
